import { Action } from 'redux';
import { DraftDesignConfiguration } from '@/types';

export enum ModalActionTypes {
  SHOW = '@modal/show',
  DISMISS = '@modal/dismiss',
}

export enum ModalTypes {
  APPEARANCE_SWITCH = 'AppearanceSwitch',
  PRODUCT_TYPE_SWITCH = 'ProductTypeSwitch',
  DESIGN_UPLOAD = 'DesignUpload',
}

export interface AppearanceSwitchProps {
  cids: number[];
  accept: () => void;
}

interface AppearanceSwitchModal {
  type: 'AppearanceSwitch';
  props: AppearanceSwitchProps;
}

export interface AppearanceSwitchModalAction extends Action {
  type: ModalActionTypes.SHOW;
  modalType: ModalTypes.APPEARANCE_SWITCH;
  props: AppearanceSwitchProps;
}

export interface ProductTypeSwitchProps {
  cids: number[];
  accept: () => void;
  reason: ProductTypeSwitchRemovalReason;
}

export type ProductTypeSwitchRemovalReason = 'printability' | 'adultContent';

interface ProductTypeSwitchModal {
  type: 'ProductTypeSwitch';
  props: ProductTypeSwitchProps;
}

export interface ProductTypeSwitchModalAction extends Action {
  type: ModalActionTypes.SHOW;
  modalType: ModalTypes.PRODUCT_TYPE_SWITCH;
  props: ProductTypeSwitchProps;
}

export interface DesignUploadProps {
  configurations: DraftDesignConfiguration[];
}

export interface DesignUploadModalProps extends DesignUploadProps {
  onCancel: () => void;
}

interface DesignUploadModal {
  type: 'DesignUpload';
  props: DesignUploadModalProps;
}

export interface DesignUploadModalAction extends Action {
  type: ModalActionTypes.SHOW;
  modalType: ModalTypes.DESIGN_UPLOAD;
  props: DesignUploadModalProps;
}

export interface DismissAction extends Action {
  type: ModalActionTypes.DISMISS;
}

export type ModalState = AppearanceSwitchModal | ProductTypeSwitchModal | DesignUploadModal | null;

export type ModalAction =
  | AppearanceSwitchModalAction
  | ProductTypeSwitchModalAction
  | DesignUploadModalAction
  | DismissAction;
